import { FEATURE_FLAGS, useFeatureFlag } from 'feature-flags';
import { REPORTING_SETTINGS_KEY_PREFIX } from 'reporting/hooks/parameter-selection-storage';
import { REPORT_TYPE } from 'reporting/constants';

export const ACTIVITY_CUSTOM_CHARTS_KEY = `${REPORTING_SETTINGS_KEY_PREFIX}${REPORT_TYPE.activity}.custom-charts`;

export function customChartParametersKey(chartId: string) {
    return `${REPORTING_SETTINGS_KEY_PREFIX}${REPORT_TYPE.activity}.custom-chart.${chartId}.parameters`;
}

export function useCustomChartsInCloud() {
    return useFeatureFlag(FEATURE_FLAGS.RELEASE_USER_CONFIG_CUSTOM_CHARTS);
}
